// eslint-disable-next-line import/prefer-default-export
export function stripHTML(html) {
  const tmp = document.createElement('DIV');
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || '';
}
